








































































































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { CUSTOMER_DETAILS } from '@/types/customer.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Grid } from '@/models/Grid.model';
import { GridColumn } from '@/models/GridColumn.model';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import { ClickColumn } from '@/models/ClickColumn.model';
import { DeleteRemindersRequest } from '@/models/backoffice/DeleteRemindersRequest';
import {
  CREATE_MESSAGE,
  DELETE_MESSAGES,
  GET_MESSAGES_ALL_OFFICE_LIST,
  GET_MESSAGES_BY_CUSTOMER,
  MESSAGES_ALL_OFFICE_LIST,
  MESSAGES_BY_CUSTOMER,
  OPEN_CREATE_MESSAGE_MODAL,
  OPEN_CREATE_MESSAGE_MODAL_ERRORS,
  OPEN_DELETE_MESSAGES_MODAL,
  OPEN_DELETE_MESSAGES_MODAL_ERRORS,
  SET_OPEN_CREATE_MESSAGE_MODAL,
  SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS,
  SET_OPEN_DELETE_MESSAGES_MODAL,
  SET_OPEN_DELETE_MESSAGES_MODAL_ERRORS,
  UPDATE_MESSAGE,
} from '@/types/backoffice/messages.types';
import { BackofficeMessageModel } from '@/models/BackofficeMessage.model';
import { Utils } from '@/globals/Utils';

@Component({})
export default class MessagesSettingsComponent extends Vue {
  @Inject() public $validator: any;

  @Action(GET_MESSAGES_BY_CUSTOMER, StoreNamespace.MESSAGES) public getMessagesByCustomer;
  @Action(GET_MESSAGES_ALL_OFFICE_LIST, StoreNamespace.MESSAGES) public getMessagesAllOfficeList;
  @Action(DELETE_MESSAGES, StoreNamespace.MESSAGES) public deleteMessages;
  @Action(CREATE_MESSAGE, StoreNamespace.MESSAGES) public createMessage;
  @Action(UPDATE_MESSAGE, StoreNamespace.MESSAGES) public updateMessage;

  @Mutation(SET_OPEN_CREATE_MESSAGE_MODAL, StoreNamespace.MESSAGES) public setOpenCreateMessageModal;
  @Mutation(SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS, StoreNamespace.MESSAGES) public setOpenCreateMessageModalErrors;
  @Mutation(SET_OPEN_DELETE_MESSAGES_MODAL, StoreNamespace.MESSAGES) public setOpenDeleteMessagesModal;
  @Mutation(SET_OPEN_DELETE_MESSAGES_MODAL_ERRORS, StoreNamespace.MESSAGES) public setOpenDeleteMessagesModalErrors;

  @Getter(MESSAGES_BY_CUSTOMER, StoreNamespace.MESSAGES) public messagesByCustomer!: Grid;
  @Getter(MESSAGES_ALL_OFFICE_LIST, StoreNamespace.MESSAGES) public allOfficesByCustomer!: Grid;
  @Getter(CUSTOMER_DETAILS, StoreNamespace.CUSTOMER) public customerDetails!: CustomerDetailsModel;
  @Getter(OPEN_CREATE_MESSAGE_MODAL, StoreNamespace.MESSAGES) public openCreateMessageModal!: boolean;
  @Getter(OPEN_CREATE_MESSAGE_MODAL_ERRORS, StoreNamespace.MESSAGES) public openCreateMessageModelErrors!: string[];
  @Getter(OPEN_DELETE_MESSAGES_MODAL, StoreNamespace.MESSAGES) public openDeleteMessagesModal!: boolean;
  @Getter(OPEN_DELETE_MESSAGES_MODAL_ERRORS, StoreNamespace.MESSAGES) public openDeleteMessagesModelErrors!: string[];

  public createMessageRequest: BackofficeMessageModel = {} as BackofficeMessageModel;
  public updateMessageMode: boolean = false;
  public columns: GridColumn[] = [];
  private deleteMessagesRequest: DeleteRemindersRequest = {} as DeleteRemindersRequest;

  public destroyed() {
    this.setOpenCreateMessageModal(false);
    this.setOpenDeleteMessagesModal(false);
  }

  public created() {
    this.createMessageRequest = {
      indexNum: this.customerDetails.indexNum,
    } as BackofficeMessageModel;
  }

  public mounted() {
    this.getMessagesAllOfficeList(this.customerDetails.indexNum);
    this.setOpenCreateMessageModal(false);
    this.setOpenDeleteMessagesModal(false);
    this.setOpenCreateMessageModalErrors([]);
    this.setOpenDeleteMessagesModalErrors([]);
    this.getMessagesByCustomer(this.customerDetails.indexNum);
    this.updateMessageMode = false;
    this.initColumns();
  }

  public initColumns() {
    this.columns.push({
      property: 'officeName',
      header: 'back_office.settings.messages.officeName',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'fromDate',
      header: 'back_office.settings.messages.fromDate',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'toDate',
      header: 'back_office.settings.messages.toDate',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'msgOrder',
      header: 'back_office.settings.messages.msgOrder',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'msgText',
      header: 'back_office.settings.messages.msgText',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      clickEvent: 'DELETE',
      mdIcon: 'delete',
      header: 'back_office.settings.reminders.delete',
    } as ClickColumn);
    this.columns.push({
      clickEvent: 'EDIT',
      mdIcon: 'edit',
      header: 'back_office.settings.messages.edit',
    } as ClickColumn);
  }

  public onTdClicked(item, column) {
    switch (column.clickEvent) {
      case 'DELETE':
        this.setOpenDeleteMessagesModal(true);
        this.setOpenDeleteMessagesModalErrors([]);
        this.deleteMessagesRequest = {
          indexNum: this.customerDetails.indexNum,
          ids: [item.id],
        };
        break;
      case 'EDIT':
        this.updateMessageMode = true;
        this.setOpenCreateMessageModalErrors([]);
        this.createMessageRequest = { ...item };
        this.createMessageRequest.fromDate = Utils.DDMMYYYYStringToDate('' + this.createMessageRequest.fromDate);
        this.createMessageRequest.toDate = Utils.DDMMYYYYStringToDate('' + this.createMessageRequest.toDate);
        this.setOpenCreateMessageModal(true);
        break;
    }
  }

  public addMessage() {
    this.updateMessageMode = false;
    this.createMessageRequest = {
      indexNum: this.customerDetails.indexNum,
    } as BackofficeMessageModel;
    this.setOpenCreateMessageModal(true);
    this.setOpenCreateMessageModalErrors([]);
  }

  public onCreateMessage() {
    this.$validator.validateAll('createMessageForm').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        this.createMessageRequest.indexNum = this.customerDetails.indexNum;
        if (this.updateMessageMode) {
          this.updateMessage(this.createMessageRequest);
        } else {
          // this.createMessageRequest.fromDate = '20201228'
          // this.createMessageRequest.toDate = '20201231'
          this.createMessage(this.createMessageRequest);
        }
      }
    });
  }

  public closeModal() {
    this.setOpenCreateMessageModal(false);
  }

  public onOfficeNums(item: any) {
    if (item) {
      this.createMessageRequest.officeNum = item;
    }
  }

  public closeDeleteMessagesModal() {
    this.setOpenDeleteMessagesModal(false);
    this.setOpenDeleteMessagesModalErrors([]);
    this.deleteMessagesRequest = {} as DeleteRemindersRequest;
  }

  public onDeleteMessagesClicked() {
    this.deleteMessages(this.deleteMessagesRequest);
    this.closeDeleteMessagesModal();
  }

  public updateDate(date: Date, property: string) {
    this.createMessageRequest[property] = date ? Utils.dateToString(date) : date;
  }

  public beforeDestroy(): void {
    this.updateMessageMode = false;
  }

}

